// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5675":"db31eea24d986736","6693":"3f2cf082955da14c"}[chunkId] + ".js";
};